import Echo from 'laravel-echo';

window.pusher = require('pusher-js');
export default new Echo({
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_APP_KEY,
  cluster: 'eu',
  authEndpoint: `${process.env.VUE_APP_API_URL}broadcasting/auth`,
  auth: { headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } }
});
